var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from "react";
import Identicon from "./Identicon";
import { Component } from "react";
import PropTypes from "prop-types";
import utils from "common/utils";

var AccountImage = function (_Component) {
    _inherits(AccountImage, _Component);

    function AccountImage() {
        _classCallCheck(this, AccountImage);

        return _possibleConstructorReturn(this, (AccountImage.__proto__ || Object.getPrototypeOf(AccountImage)).apply(this, arguments));
    }

    _createClass(AccountImage, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(np) {
            return !utils.are_equal_shallow(np, this.props);
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                account = _props.account,
                image = _props.image,
                style = _props.style;
            var _props$size = this.props.size,
                height = _props$size.height,
                width = _props$size.width;

            var custom_image = image ? React.createElement("img", { src: image, height: height + "px", width: width + "px" }) : React.createElement(Identicon, { id: account, account: account, size: this.props.size });

            return React.createElement(
                "div",
                { style: style, className: "account-image" },
                custom_image
            );
        }
    }]);

    return AccountImage;
}(Component);

AccountImage.defaultProps = {
    src: "",
    account: "",
    size: { height: 120, width: 120 },
    style: {}
};

AccountImage.propTypes = {
    src: PropTypes.string,
    account: PropTypes.string,
    size: PropTypes.object.isRequired,
    style: PropTypes.object
};

export default AccountImage;